import React from 'react';
import { FaGithub, FaFacebook, FaLinkedin } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';

const Footer = () => {
    const today = new Date();
    const year = today.getFullYear();
    return (
        <section className='bg-dark bg-gradient p-5' style={{ marginTop: "100px" }}>
            <div className='container text-light text-center'>
                <h2>Md. Saimon Sikder Srayo</h2>
                <p className='font-monospace'>&copy; All rights reserved by Srayo {year}</p>
                <div className='mx-auto text-center'>
                    <a href="https://github.com/srayo16" target='_blank' rel="noreferrer" ><FaGithub className='me-3 fs-2 text-info icon-hovers'></FaGithub></a>
                    <a href="https://www.linkedin.com/in/srayo-sikder/" target='_blank' rel="noreferrer" ><FaLinkedin className='me-3 fs-2 text-info icon-hovers'></FaLinkedin></a>
                    <a href="https://www.facebook.com/profile.php?id=100009355720684" target='_blank' rel="noreferrer" ><FaFacebook className='me-3 fs-2 text-info icon-hovers'></FaFacebook></a>
                    <a href="mailto:srayosikder@gmail.com" target='_blank' rel="noreferrer"><FiMail className='me-3 fs-2 text-dark rounded bg-info icon-hovers'></FiMail></a>
                </div>
            </div>
        </section>
    );
};

export default Footer;